import { useQuery } from '@tanstack/react-query';
import { httpClient } from '../../services/http.client';
import { queryKeys } from '../../lib/query-keys';

export function useBoqs(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.boqs.all(orgId ?? ''),
    queryFn: () => httpClient.get(`/api/v1/boqs?organization_id=${orgId}`),
    enabled: !!orgId,
    staleTime: 5 * 60_000,
    select: (res: any) => {
      const raw = res?.data ?? res;
      return Array.isArray(raw) ? raw : [];
    },
  });
}

export function useBoqItems(boqId: string | null) {
  return useQuery({
    queryKey: queryKeys.boqs.items(boqId ?? ''),
    queryFn: () => httpClient.get(`/api/v1/boqs/${boqId}/items`),
    enabled: !!boqId && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(boqId!),
    staleTime: 30_000,
    select: (res: any) => {
      const raw = res?.data ?? res;
      return Array.isArray(raw) ? raw : [];
    },
  });
}
